import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import { useAuth } from 'root/hooks/useAuth';

import Box from 'base-ui/dist/Box';
import Slider from 'base-ui/dist/Slider';
import Heading from 'base-ui/dist/Heading';

import PostCard from 'components/PostCard';
import apiClient from '../../lib/apiClient';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const RelatedDrugsSlider = ({
  className, title, titleType, data
}) => {
  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  return (
    <Box tag="section" className={`section-featured-posts  ${className}`}>
      {title && (
        <Heading type={titleType} className="titleLine">{title}</Heading>
      )}
      <div className="slick-initialized slick-slider">
        <Slider
          autoplay
          dots
          className="category-slider big posts-row"
          slidesToShow={1}
          slidesToScroll={1}
          responsive={[
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]}
        >
          {data.map((item) => (
            <PostCard
              key={item.id}
              post={item}
              isAuthenticated={isAuthenticated}
              bookmarks={bookmarks}
              handleBookmarks={setBookmarks}
            />
          ))}
        </Slider>
      </div>

    </Box>
  );
};

RelatedDrugsSlider.defaultProps = {
  className: '',
};

RelatedDrugsSlider.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string,
  titleType: PropTypes.string,
  className: PropTypes.string
};

export default RelatedDrugsSlider;
